module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921112651_T.4f4ffbb7.jpg";